export enum RoutePaths {
  root = "/",
  registration = "/registration",
  login = "/login",
  remindPassword = "/remind-password",
  specificWishlist = "/wishlist/:wishlistId",
  myDefaultWishlist = "/wishlist",
  wishlistItem = "/wishlist/:wishlistId/:wishId",
  newWish = "/wishlist/:wishlistId/new",
  editWish = "/wishlist/:wishlistId/:wishId/edit",
  logout = "/logout",
  friends = "/friends",
  termsOfUse = "/terms",
  privacyPolicy = "/privacy",
  reserved = "/reserved",
  account = "/account",
  accountEdit = "/account/edit",
  accountEditEmail = "/account/edit-email",
  notifications = "/notifications",
  contactUs = "/contact-us",
  faq = "/faq",
}
